import Cookies from 'js-cookie';

const conf = mpro.config.cookie;

// Extend with default options and set Cookies as mpro module
mpro.Cookies = Cookies.withAttributes({
	path: conf.path,
	domain: conf.domain,
	secure: conf.secure,
	sameSite: conf.samesite,
});

export default mpro;
